import type { ScreenerTableData } from '../../DataProvider/ScreenerTableMultiMetricProvider';
import { ChartCard, type ChartProps } from '../ChartRoot/Chart';
import { ScreenerTable } from './ScreenerTable';
import styles from './ScreenerTableChartContent.module.css';

type ScreenerTableChartContentProps = Pick<ChartProps, 'onClick'> & {
  data?: ScreenerTableData;
};

export const ScreenerTableChartContent = ({
  data,
  onClick,
}: ScreenerTableChartContentProps) => {
  if (!data) {
    return null;
  }

  return (
    <ChartCard onClick={onClick} isRelative variant="screener">
      <div data-testid="card-body" className={styles.body}>
        <ScreenerTable data={data} />
      </div>
    </ChartCard>
  );
};
